import { render, staticRenderFns } from "./DialogPatientSearchMail.vue?vue&type=template&id=bf02844e&scoped=true"
import script from "./DialogPatientSearchMail.vue?vue&type=script&lang=js"
export * from "./DialogPatientSearchMail.vue?vue&type=script&lang=js"
import style0 from "./DialogPatientSearchMail.vue?vue&type=style&index=0&id=bf02844e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf02844e",
  null
  
)

export default component.exports